import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestCustomerCategoryEdit from './request/requestCustomerCategoryEdit'
import requestCustomerCategoryRegister from './request/requestCustomerCategoryRegister'
import { i18n } from '@/main.js'

const Actions = {
  // GP03 消費税マスタ取得
  getConsumptionTaxListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.CONSUMPTION_TAX_LIST)
      .get(api.CONSUMPTION_TAX_LIST)
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_CONSUMPTION_TAX_LIST
        commit(path, response.data.data)
        const getData = getters.getTaxRateListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP01 通貨一覧取得API
  getCurrencyListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.CURRENCY_LIST)
      .get(api.CURRENCY_LIST)
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_CURRENCY_LIST
        commit(path, response.data.data)
        const getData = getters.getCurrencyListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP02 国マスタ取得
  getCountryListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.COUNTRY_LIST)
      .get(api.COUNTRY_LIST)
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_COUNTRY_LIST
        let countryList = response.data.data.countryList
        // 表示名でソート
        countryList.sort((country1, country2) => {
          if (country1.name < country2.name) {
            return -1
          } else if (country1.name > country2.name) {
            return 1
          }
          return 0
        })
        // 日本と中国のみ先頭に再配置
        const japaneseIndex = countryList.findIndex((countryCallingCode) => {
          return countryCallingCode.countryId === 88
        })
        const japaneseObject = countryList[japaneseIndex]
        const chineseIndex = countryList.findIndex((countryCallingCode) => {
          return countryCallingCode.countryId === 33
        })
        const chineseObject = countryList[chineseIndex]
        countryList.splice(japaneseIndex, 1)
        countryList.splice(chineseIndex, 1)
        countryList.unshift(japaneseObject, chineseObject)

        commit(path, { countryList })
        const getData = getters.getCountryListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP04 国電話コードマスタ取得
  getCountryCallingCodeListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.COUNTRY_CALLING_CODE_LIST)
      .get(api.COUNTRY_CALLING_CODE_LIST)
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_COUNTRY_CALLING_CODE_LIST
        let countryCallingCodeList = response.data.data.countryCallingCodeList
        countryCallingCodeList.forEach((countryCallingCode) => {
          const countryId = countryCallingCode.countryId
          const countryName = state.countryList.find(
            (country) => country.countryId === countryId
          ).name
          countryCallingCode.countryName = countryName
        })
        commit(path, { countryCallingCodeList })
        const getData = getters.getCountryCallingCodeListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP05 顧客分類マスタ取得
  getCustomerCategoryListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.CUSTOMER_CATEGORY_LIST)
      .get(api.CUSTOMER_CATEGORY_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_CUSTOMER_CATEGORY_LIST
        commit(path, response.data.data)
        const getData = getters.getCustomerCategoryFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP06 商品カテゴリ取得
  getProductCategoryListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.PRODUCT_CATEGORY_LIST)
      .get(api.PRODUCT_CATEGORY_LIST)
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_PRODUCT_CATEGORY_LIST
        commit(path, response.data.data)
        const getData = getters.getProductCategoryFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP07 顧客分類マスタ登録
  registerCustomerCategory: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestCustomerCategoryRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.CUSTOMER_CATEGORY_REGISTER_EDIT)
      .post(api.CUSTOMER_CATEGORY_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP08 顧客分類マスタ編集
  editCustomerCategory: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestCustomerCategoryEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.CUSTOMER_CATEGORY_REGISTER_EDIT)
      .patch(`${api.CUSTOMER_CATEGORY_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP12 ブランド一覧取得
  getBrandListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.BRAND_LIST)
      .get(api.BRAND_LIST)
      .then((response) => {
        const path = mutationsTypes.COMMON_SET_BRAND_LIST
        commit(path, response.data.data)
        const getData = getters.getBrandListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP09 在庫調整理由マスタ取得
  getStockAdjustReasonListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.STOCK_ADJUST_REASON_LIST)
      .get(api.STOCK_ADJUST_REASON_LIST)
      .then((response) => {
        const path = mutationsTypes.STOCK_ADJUST_SET_STOCK_ADJUST_REASON_LIST
        commit(path, response.data.data)
        const getData = getters.getStockAdjustReasonListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        console.log(error.response)
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // GP11 よく使う画面設定用画面取得
  getOftenUseScreenListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.OFTEN_USE_SCREEN)
      .get(api.OFTEN_USE_SCREEN)
      .then((response) => {
        const path = mutationsTypes.OFTEN_USE_SET_SCREEN_LIST
        commit(path, response.data.data)
        const getData = getters.getOftenUseScreenListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // APIアラート表示したかフラグのセット
  setHasDisplayedAlertFlg: (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const path = mutationsTypes.COMMON_SET_DISPLAY_API_ALERT
    commit(path, params)
  },
  // GP10 為替レート取得
  getFxRateListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.FX_RATE_COMBINATION_LIST)
      .get(api.FX_RATE_COMBINATION_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.FX_SET_FX_RATE_LIST
        commit(path, response.data.data)
        const getData = getters.getFxRateListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // 言語設定
  setLang({ state, dispatch, commit, getters, rootGetters, rootState }, lang) {
    const path = mutationsTypes.LANG_SET_TYPE
    commit(path, lang)
  },
  // 帳票出力
  getLedgerSheet: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    path
  ) => {
    return await axios
      // .get(apiMock.FX_RATE_COMBINATION_LIST)
      .get(path, { responseType: 'blob' })
      .then((response) => {
        const path = mutationsTypes.LEDGER_SHEET_HEADER
        commit(path, response)
        return true
      })
      .catch((error) => {
        if (error.response.status) {
          alert(i18n.tc('common.common_ledger-sheet-over-data-alert'))
        } else {
          commonUtil.afterApiFailProcess(error.response)
        }
        return false
      })
  },
  // ローディングの表示・非表示
  setIsLoading(
    { state, dispatch, commit, getters, rootGetters, rootState },
    isLoading
  ) {
    commit(mutationsTypes.SET_IS_LOADING, { isLoading })
  },
  resetIsLoading({ state, dispatch, commit, getters, rootGetters, rootState }) {
    commit(mutationsTypes.RESET_IS_LOADING)
  }
}

export default Actions
